<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">DIAGEO TÜRKİYE</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            DIAGEO TÜRKİYE Parola Değiştirme
          </b-card-title>
          <b-card-text class="mb-2">
            Parolanız 90 gündür kullanımda olduğu için değiştirmeniz gerekmektedir.
          </b-card-text>

          <!-- <b-alert
                variant="primary"
                show
              >
                <div class="alert-body font-small-2">
                  <p>
                    <small class="mr-50"><span class="font-weight-bold">Admin:</span> admin@demo.com | admin</small>
                  </p>
                  <p>
                    <small class="mr-50"><span class="font-weight-bold">Client:</span> client@demo.com | client</small>
                  </p>
                </div>
                <feather-icon
                  v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
                  icon="HelpCircleIcon"
                  size="18"
                  class="position-absolute"
                  style="top: 10; right: 10;"
                />
              </b-alert> -->

          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Kullanıcı" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Parola</label>
                  <!-- <b-link :to="{name:'auth-forgot-password'}">
                        <small>Parolamı Unuttum?</small>
                      </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder=""
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Yeni Parola</label>
                  <!-- <b-link :to="{name:'auth-forgot-password'}">
                        <small>Parolamı Unuttum?</small>
                      </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="newPassword"
                  vid="newPassword"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="newPassword"
                      v-model="newPassword"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="newPassword"
                      placeholder=""
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Yeni Parola Tekar</label>
                  <!-- <b-link :to="{name:'auth-forgot-password'}">
                        <small>Parolamı Unuttum?</small>
                      </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="newPasswordAgain"
                  vid="newPasswordAgain"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="newPasswordAgain"
                      v-model="newPasswordAgain"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="newPasswordAgain"
                      placeholder=""
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox id="remember-me" v-model="status" name="checkbox-1">
                  Beni Hatırla
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block :disabled="invalid">
                Parolayı Değiştir
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
                <span>New on our platform? </span>
                <b-link :to="{name:'auth-register'}">
                  <span>&nbsp;Create an account</span>
                </b-link>
              </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
                <div class="divider-text">
                  or
                </div>
              </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
                <b-button
                  variant="facebook"
                  href="javascript:void(0)"
                >
                  <feather-icon icon="FacebookIcon" />
                </b-button>
                <b-button
                  variant="twitter"
                  href="javascript:void(0)"
                >
                  <feather-icon icon="TwitterIcon" />
                </b-button>
                <b-button
                  variant="google"
                  href="javascript:void(0)"
                >
                  <feather-icon icon="MailIcon" />
                </b-button>
                <b-button
                  variant="github"
                  href="javascript:void(0)"
                >
                  <feather-icon icon="GithubIcon" />
                </b-button>
              </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BModal,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();
export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    // BAlert,
    BModal,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      verificationCode: "",
      modalShow: false,
      status: "",
      password: "",
      newPassword: "",
      newPasswordAgain: "",
      userEmail: "",
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      // validation rules
      required,
      email,
      verificationCodeErrors: {},
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          endpoints
            .postPasswordChangeExpired(
              {
                email: this.userEmail,
                password: this.password,
                newPassword: this.newPassword,
                newPasswordAgain: this.newPasswordAgain,
              },
              this.$i18n.locale
            )
            .then((data) => {
              if (data.errors) {
                const formattedErrors = {};
                // Hataları set et
                Object.keys(data.errors).forEach((field) => {
                  formattedErrors[field] = data.errors[field][0];
                });
                this.$refs.loginForm.setErrors(formattedErrors);
              } else {
                console.log("Başarılı", data);
                if (data.status) {
                  this.$router.replace("/login");
                } else {
                  this.$refs.loginForm.setErrors(data.errors);
                }
              }
            })
            .catch((error) => {
              console.error("API Hatası:", error);
            });
        } else {
          // Geçersiz form durumu
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Hata`,
              icon: "AlertCircleIcon",
              variant: "danger",
              text: `Form verileriniz hatalı!`,
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
